import React, { PropTypes } from 'react';
import cn from 'classnames';
import { Button } from '../../../shared';

/**
 * onClick on mobile has a very bad threshold for
 * registering. for this reason we use mouse
 * down or touch start.
 *
 *  e.g. if the users finger moves very slightly it is not
 *       counted
 */
const HANDLER = ['android', 'ios'].includes(window.platform)
  ? 'onTouchStart'
  : 'onClick';

export default class KeypadButton extends React.PureComponent {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    addDigit: PropTypes.func.isRequired,
    className: PropTypes.string,
    number: PropTypes.string.isRequired,
  };

  handleClick = (event) => {
    event.preventDefault();
    this.props.addDigit(this.props.number);
  }

  render() {
    const props = {
      [HANDLER]: this.handleClick,
      className: cn(
        'key',
        'charcoal',
        this.props.className,
        { active: this.props.isActive },
      ),
    };

    return (
      <Button {...props}>
        <p>{this.props.number}</p>
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/timeclock/keypad/keypadbutton/index.jsx